import {useRouter} from 'next/router';
import React, {useCallback, useContext, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {selectClinicData} from '@/src/app/store/clinic/clinicDataSlice';
import PopupContext from '@/src/popup/utils/PopupContext';
import ClinicAddressWidgetLayout from '@/src/profile/accountSettings/components/ClinicAddressWidgetLayout';
import ChangeClinicAddressPopup from '@/src/profile/accountSettings/containers/ChangeClinicAddressPopup';

const ClinicAddressWidget = () => {
  const {locale} = useRouter();
  const {clinicData} = useSelector(selectClinicData);
  const {openPopup} = useContext(PopupContext);
  const locationFieldName = useMemo(() => {
    return `name_${locale}`;
  }, [locale]);

  const handleChangeAddressClick = useCallback(() => {
    // @ts-ignore
    openPopup({
      popup: <ChangeClinicAddressPopup />,
      options: {withCloseButton: true},
    });
  }, []);

  return (
    <ClinicAddressWidgetLayout
      address={clinicData?.address}
      city={clinicData?.city?.[locationFieldName]}
      state={clinicData?.state?.[locationFieldName]}
      country={clinicData?.country?.[locationFieldName]}
      zipcode={clinicData?.zipcode}
      onChangeAddressClick={handleChangeAddressClick}
    />
  );
};

export default ClinicAddressWidget;
